import { ArrowRightIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { RailsBlock } from '~/typings/services/rails/tile';

interface Props extends React.HTMLAttributes<HTMLElement> {
  cta?: React.ReactNode;
  block: RailsBlock;
  headerType?: 'h1' | 'h2' | 'h3';
  showCta?: boolean;
}

const BlockSection: React.FC<Props> = ({
  cta,
  block,
  children,
  headerType: Header = 'h3',
  showCta = true,
  ...props
}) => {
  const LinkElement = block.destination == null ? 'div' : 'a';

  return (
    <section
      className="container"
      id={`${block.layout}-${block.id}`}
      {...props}
    >
      {block.title && (
        <LinkElement href={block.destination}>
          <Header className="mb-2 inline-flex items-center gap-2 text-lg">
            <span>{block.title}</span>
            {!!block.destination && <ArrowRightIcon className="h-4 w-4" />}
          </Header>
        </LinkElement>
      )}

      {children}
    </section>
  );
};

export default BlockSection;
